const isBagPage = path => !!path.match(/^(\/[a-zA-Z]{2})?\/bag(\/$|$)/);

const isFailedOrderPage = path =>
  /^(\/[a-z]{2})?\/failed-order(\/?$)/i.test(path);

const pageSupportsMiniBagWithDropdown = path =>
  !isBagPage(path) && !isFailedOrderPage(path);

export default pageSupportsMiniBagWithDropdown;
